<template>
    <div>
        <modal
            class="new-modal-small"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="500"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false"
        >
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #fff !important; height: 110% !important;">
                <div class="upload-bulk pl-5 pr-5">
                    <div class="header-text pt-5 pb-4"> 
                        <span>Adding data to Lead</span>
                    </div>
                    <div class="fs-14 fw-500 pb-2" style="text-align: left !important;"> 
                        <span v-if="attachments.length == 0">Upload File</span>
                        <span v-else-if="attachments[0].uploading">Uploading File...</span>
                        <span v-else>Uploaded File</span>
                    </div>
                    <div v-if="attachments.length == 0" class="attachment-bg pt-2">
                        <div class="d-flex justify-content-center">
                            <div class="pl-15 pr-15 text-center bg-white py-6" @drop="dropHandlerInside($event)" @dragover="dragOverHandlerInside($event)">
                                <div>
                                    <img src="/static/images/download-upload.svg" alt="" width="50px" height="30px">
                                </div>
                                <div class="text-color pt-2">Upload Excel Sheet</div>
                                <label class="click-here pointer mt-1">
                                <input type="file" :multiple="false" draggable @change="uploadAttachment" accept=".xls, .xlsx">
                                    Click here
                                </label>
                            </div>
                        </div>
                    </div> 
                    <div v-else class="d-flex flex-wrap align-items-center mt-2">
                        <div class="col-lg-12 col-md-12 col-sm-12" v-for="(attachment,index) in attachments" :key="index">
                            <div class="d-flex align-items-center mt-6 pr-6">
                                <div class="d-flex align-items-center" style="width:100%">
                                    <div>
                                        <!-- <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                        <img v-else-if="attachment.name.endsWith('.png')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                        <img v-else-if="attachment.name.endsWith('.jpg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                        <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg"> -->
                                        <img v-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                        <!-- <img v-else-if="attachment.name.endsWith('.xlsx') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg"> -->
                                        <!-- <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg"> -->
                                    </div>
                                    <div class="col">
                                        <div class="d-flex justify-content-between">
                                            <el-tooltip :content="attachment.name" placement="top">
                                                <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                    {{attachment.name}}
                                                </div>
                                            </el-tooltip>
                                            
                                        </div>
                                        <div v-if="attachment.uploading || attachment.url == undefined">
                                            <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                        </div>    
                                        <div class="d-flex justify-content-between">
                                            <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}...</div>
                                            <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploaded</div>
                                            <div class="fw-500">({{attachment.size | prettyBytes}})</div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="is_get_api_in_progress == false" class="pointer ml-3" style="width:10%" @click="deleteAttachment(attachment,index)">
                                    <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                    <i class="icon icon-trash text-secondary fs-20" v-if="attachment.url && attachment.uploading == false"></i>
                                </div>
                            </div>
                        </div>    
                    </div>
                </div>
                <div class="d-flex aligin-items-center justify-content-center mt-6 mb-6">
                    <button class="btn new-cancel-button mr-4 px-4" :disabled="is_get_api_in_progress" @click="closeModal">Cancel</button>
                    <button v-if="showValidateButton" class="btn new-yes-button ml-4 px-4" :disabled="is_get_api_in_progress || attachments.length == 0 || attachments[0].uploading" @click="bulkValidation">Validate File
                        <hollow-dots-spinner v-if="is_get_api_in_progress" style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                    </button>
                    <button v-if="showUploadButton" class="btn new-yes-button ml-4 px-4" :disabled="is_get_api_in_progress || attachments.length == 0 || attachments[0].uploading" @click="uploadBulk">Upload File
                        <hollow-dots-spinner v-if="is_get_api_in_progress" style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                    </button>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <file-error v-if="showErrorfile" modal_name="errorBulkUpload" @hideErrorFile="hideErrorFile" :warning_msg="warning_msg"></file-error> 
    </div>
</template>

<script>
import attachments from "../mixins/bulkAttachments"
import leads from "../mixins/leads"
import { HollowDotsSpinner } from "epic-spinners";
import { SweetModal } from 'sweet-modal-vue'
import FileError from "./FileError"
import { EventBus } from '../eventBus/nav-bar-event';
export default {
    props: ["modal_name"],
    mixins:[attachments, leads],
    data() {
        return{
            success_msg: "",
            warning_msg: "",
            disableButtonAndDisplayLoader: false,
            attachments: [],
            is_get_api_in_progress: false,
            showRejected: true,
            showValidateButton: true,
            showUploadButton: false,
            showErrorfile: false,
        }
    },
    components: {
        HollowDotsSpinner,SweetModal,FileError
    },
    methods: {
        hideErrorFile(){
            this.showErrorfile = false;
        },
        dropHandlerInside(evt) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
            // Use DataTransfer interface to access the file(s)
            [...evt.dataTransfer.files].forEach((file, i) => {
                this.uploadAttachmentInsideFromDrop(file)
            });
        },
        dragOverHandlerInside(evt) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
        },
        deleteAttachment(attachment,index){
            this.attachments.splice(index,1)
            if(attachment.url == undefined){
                this.check_attachments = false
            }
        },
        async uploadBulk() {
            this.is_get_api_in_progress = true;
            try {
                let payload = {
                    link: this.attachments[0].url
                };
                // let temp_payload = JSON.parse(JSON.stringify(payload))
                // temp_payload.attachments.forEach((attachment, at_i)=>{
                //     delete attachment.error
                //     delete attachment.id
                //     delete attachment.uploading
                //     delete attachment.progress
                //     delete attachment.source
                // })
                let response = await this.bulkLeadUpload(payload)
                this.success_msg = response.message;
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.is_get_api_in_progress = false;
                    this.$emit('hideBulkUpload', true)
                }, 3000);
            }
            catch(err) {
                // console.log(err)
                this.is_get_api_in_progress = false;
            }
        },
        async bulkValidation(id) {
            this.is_get_api_in_progress = true;
            try {
                let payload = {
                    link: this.attachments[0].url
                };
                let response = await this.bulkLeadValidation(payload);
                this.success_msg = response.errors;
                this.showValidateButton = false;
                this.showUploadButton = true;
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.is_get_api_in_progress = false;
                }, 3000);
            }
            catch(err) {
                this.warning_msg = err;
                this.showErrorfile = true;
                setTimeout(() => {
                    this.$modal.show('errorBulkUpload')
                }, 500);
                // this.$refs.warning_modal.open();
                // setTimeout(() => {
                //     this.$refs.warning_modal.close();
                // }, 2000);
                this.is_get_api_in_progress = false;
            }
        },
        closeModal() {
            this.$emit("hideBulkUpload", false);
        },
    },
    created() {
        // Sets up the Event Bus listener using 
        // the custom event name and assosciates
        // it with a component method.
        EventBus.$on("bulkValidation", this.bulkValidation);
      },
    destroyed() {
        // Removes Event Bus listener upon removal
        // of template from DOM.
        EventBus.$off("bulkValidation", this.bulkValidation);
      },
}
</script>
<style>
    .attachment-bg {
        background-color: #fff !important;
        border: 1.5px dashed #89898d;
        padding: 15px;
        border-radius: 10px;
        width: 100%;
    }
    .upload-bulk{
        margin: 10px !important;
        width: 100%;
    }
    .click-here{
        color: #206ad3;
        text-decoration: underline;
        font-size: 12px;
    }
    .text-color{
        color: #c6c7c9;
        font-size: 16px;
    }
    .header-text{
        color: #00448b;
        font-size: 18px;
        font-weight: 600;
    }
    .new-modal-small.v--modal-overlay .v--modal-box{
        max-width: 600px !important;
        width: 600px !important;
    }
    .new-modal-small.v--modal-overlay .v--modal-box.v--modal {
        height: auto !important;
        left: 28% !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Leads/AddBulkUpload.vue